// extracted by mini-css-extract-plugin
module.exports = {"DataTable":"DataTable_DataTable_3AQv6","ExtendTable":"DataTable_ExtendTable_2af9K","TableTitle":"DataTable_TableTitle_1lalc"};